import * as types from "./actionTypes";

export const togglePriceWorksheetOpened = (priceWorksheetOpened) => ({
  type: types.TOGGLE_PRICE_WORKSHEET_OPENED,
  payload: {
    priceWorksheetOpened
  }
});

export const setDiscountSections = (discountSections) => ({
  type: types.SET_DISCOUNT_SECTIONS,
  payload: {
    discountSections,
  }
});
